import axios from 'axios'
import store from '~/js/store'

let url = '/ajax/form_submit.php'

let getFormData = function(modal) {
  let data

  data = new FormData()
  data.append('form_id', modal.formId)

  modal.fields.map(function(field) {
    if (field.type === 'file') {
      data.append(field.name, field.value)
    } else {
      data.append('form['+field.name+']', field.value)
    }
  })


  modal.hiddenFields.map(function(field) {
    if (field.id === 'Pagelinkfield') {
      data.append('form['+field.name+']', window.location.pathname)
    }

    if ((field.id === 'ProductNamefield') && store.state.productInfo && (typeof store.state.productInfo.NAME != 'undefined')) {
      data.append('form['+field.name+']', store.state.productInfo.NAME)
    }
  })

  if ((typeof window.recaptcha !== 'undefined') &&
    (typeof window.recaptcha.getToken === 'function')) {
    data.append('recaptcha_token',  window.recaptcha.getToken());
  }

  return data;
}

let sendform = function(modal) {
  return axios({
    method: 'post',
    url: url,
    data: getFormData(modal)
  });
}

export default sendform
